import { Component, OnInit, forwardRef, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { ConfigService } from 'src/app/services/config.service';
import { LoadingDropdown } from '../loading-dropdown.component';
import { Dropdown } from 'primeng/dropdown';


export function createValidator() {
  return (c: UntypedFormControl) => {
    const err = {
      required: true
    };

    return !c.value ? err : null;
  };
}

@Component({
  selector: 'app-country-dropdown',
  template: `
        <p-dropdown
            [styleClass]="loadingStyleClass"
            [options]="countries"
            optionLabel="countryName"
            optionValue="country"
            [ngModel]="value"
            (ngModelChange)="countrySetterFromNg($event)"
            placeholder="Country"
            [disabled]="disabled || loading || countries.length === 0"
            [required]="!optional"
            [inputId]="id + 'Input'"
            [filter]="true"
        ></p-dropdown>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CountryDropdownComponent),
    multi: true
  }, {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => CountryDropdownComponent),
    multi: true
  }]
})
export class CountryDropdownComponent extends LoadingDropdown implements ControlValueAccessor, OnInit {

  constructor(private log: NGXLogger, private configService: ConfigService, private el: ElementRef) {
    super();
  }

  propagateChange: (_: string | undefined) => void = () => {
    // default to empty.
  };

  validateFn: (c: UntypedFormControl) => object | null = () => {
    return null;
  };

  countries: object[] = [];

  @Input() ngModel: string | undefined = '';
  @Input() disabled = false;
  @Input() optional = false;
  @Input() id: string | undefined;

  @Output() ngModelChange = new EventEmitter<string>();
  @ViewChild(Dropdown) dd!: Dropdown;

  countrySetterFromNg(evt: string) {
    this.log.trace('ng setting country to ' + evt);
    this.value = evt;
  }

  get value() {
    return this.ngModel;
  }

  set value(val) {
    this.log.trace('country: setter: ' + val);
    // try allowing undefined but not null.
    if (val === null) {
      return;
    }
    this.ngModel = val;
    this.ngModelChange.emit(val);
    window.setTimeout(() => {
      this.propagateChange(val);
    }, 0);
  }

  ngOnInit() {
    // let's try to add a listener to move the focus when the label is clicked.
    const elmt = this.el.nativeElement.closest('div') as HTMLDivElement;
    if (elmt) {
      let labels = elmt.getElementsByTagName('label');
      // if no labels found, try one level higher.
      if (labels.length === 0) {
        if (elmt.parentElement) {
          labels = elmt.parentElement.getElementsByTagName('label');
        }
      }
      if (labels.length > 0) {
        const lbl = labels[0] as HTMLLabelElement;
        if (lbl.htmlFor === this.id) {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const self = this;
          lbl.addEventListener('click', () => {
            self.dd.focus();
          });
        }
      }
    }



    this.validateFn = this.optional ? () => null : createValidator();
    this.loading = true;

    this.configService.getCountries().subscribe({
      next: countries => {
        this.countries = countries || [];
      },
      complete: () => this.loading = false
    });
  }

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(fn: (_: string | undefined) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched() {
    // default to empty
  }

  validate(c: UntypedFormControl) {
    return this.validateFn(c);
  }
}

